<template>
    <modal :show="show" @close="close" :closeOnbackdrop="false">
        <template slot="header">
            <h3>
                Purchase Order
                <template v-if="purchaseStep <= purchaseStepLimit">
                    - Step {{ purchaseStep }}/{{ purchaseStepLimit }}
                </template>
                <template v-else-if="purchaseStep == 3">
                    - Confirmation
                </template>
            </h3>
        </template>
        <template>
            <div v-show="purchaseStep == 1">
                <purchase-items @data="setItemChanges" @mounted="get_cars" @done="reviewStep" :items="items" :tax="tax" :tariff="tariff" :dropshipfee="drop_ship_fee" :freightsurcharge="freight_surcharge" :reels="reels" :cars="cars" :project="survey" :done="itemsDone"></purchase-items>
            </div>
            <div v-show="purchaseStep == 2">
                <shipping-detail 
                    @data="getShippingDetail" 
                    :customer_details="customer_details" 
                    :done="shippingDetailSelectDone"
                    :po_by_car="po_by_car"
                    :stype="stype"
                    :itemleadtime="itemLeadTime"
                >
                </shipping-detail>
                <payment-method 
                    @data="getPaymentMethod" 
                    :customer_details="customer_details" 
                    :done="paymentMethodSelectDone" 
                    :cars="cars"
                    :shippingDetail="shippingDetail"
                    @po_by_car="getPoByCar"
                    :stype="stype"
                ></payment-method>
            </div>
            <div v-show="purchaseStep == 3">
                <div class="alert alert-success">
                    <strong>Purchased Successfully!</strong>
                </div>
                <iframe :src="'/api/confirmation/'+purchased_id" class="confirmation" v-if="purchased_id"></iframe>
            </div>
        </template>
        <template slot="footer">
            <button v-show="purchaseStep > 1 && purchaseStep < 3" class="btn" type="button" @click="prevStep">Back</button>
            <button class="btn btn-black" type="button" :disabled="isStepLoading" @click="nextStep" v-if="purchaseStep < 3">
                <template v-if="isStepLoading"><span class="fa fa-spinner fa-pulse"></span></template>
                <template v-else-if="purchaseStep == 2">Confirm</template>
                <template v-else>Next</template>
            </button>
            <button class="btn btn-black" type="button" @click="close" v-if="purchaseStep == 3">OK</button>
        </template>
    </modal>
</template>
<script>
import PurchaseItems from '../../components/PurchaseItems.vue'
import ShippingDetail from '../../components/ShippingDetail.vue'
import PaymentMethod from '../../components/PaymentMethod.vue'

export default {
    data() {
        return {
            user: {},
            showConfirm: false,
            isStepLoading: false,
            purchased_id: false,
            purchaseStep: 1,
            purchaseStepLimit: 3,
            startDocusign: false,
            DSStatus: null,
            itemsDone: false,
            shippingDetailSelectDone: false,
            shippingDetail: {},
            paymentMethodSelectDone: false,
            paymentMethod: {},
            cars: [],
            items: [],
            reels: [],
            tax: 0,
            tariff: 0,
            drop_ship_fee: 0,
            freight_surcharge: 0,
            itemChanges: false,
            customer_details: {},
            po_by_car: false,
            stype:'regular',
            itemLeadTime: { has_item_lead_time: false, lead_time: 0 }
        }
    },
    components: {
        PurchaseItems,
        ShippingDetail,
        PaymentMethod
    },
    props: {
        show: Boolean,
        survey: {
            type: [String, Object, Array, Boolean],
            default: "",
            description: "Model"
        },
    },
    watch: {
        show() {
            console.log('watch','show');
            this.purchaseStep = 1;
            this.get_cars();
        },
        survey: {
            handler: function(data) {
                // console.log('watch',data);
                // console.log('data-purch',data);
                this.stype = data.type;
                if ( data.status == 'REQUESTED' ) {
                    this.DSStatus = 'completed';
                    this.pdf_ds_documents = data.pdf_ds_documents;
                }
            }
        }
    },
    mounted() {
        this.get_customer_details()
    },
    methods: {
        nextStep() {
            let fdata = new FormData()
            let now = new Date

            switch(this.purchaseStep) {
                case 1: { // Review
                    if ( !this.itemsDone ) {
                        alert('Please check "I reviewed all the verified Items listed above."');
                        return false;
                    }
                    this.$http.post('/api/purchase/recheck/'+this.survey.id);
                    this.purchaseStep = 2
                    break;
                }
                case 2: { // Shipping & Payment
                    this.isStepLoading = true
                    this.shippingDetailSelectDone = now.getTime();
                    this.paymentMethodSelectDone = now.getTime();

                    // wait
                    setTimeout(() => {

                        if ( !this.paymentMethod.validated || !this.shippingDetail.validated ) {
                            alert('Please fill all enabled fields.');
                            this.isStepLoading = false;
                            return false;
                        }

                        fdata.append('survey_id', this.survey.id)
                        delete this.shippingDetail.validated
                        delete this.paymentMethod.validated

                        // append shipping details to form data
                        for(let prop in this.shippingDetail) {
                            fdata.append(prop, this.shippingDetail[prop])
                        }
                        //end

                        // append payment method to form data
                        for(let prop in this.paymentMethod) {
                            if(this.paymentMethod.payment_type == 'po' && prop == 'po') {
                                if(this.paymentMethod.po_by_car) {
                                    for(let key in this.paymentMethod[prop]) {
                                        let po = this.paymentMethod[prop][key]
                                        fdata.append('po_number[]', po.number)
                                        Array.from(po.file).forEach(file => {
                                            fdata.append(`po_file[${key}][]`, file, file.name)
                                        })
                                        fdata.append('po_car_num[]', po.car_num)
                                        fdata.append('po_car_id_number[]', po.car_id_number)
                                        fdata.append('po_delivery_date[]', po.delivery_date)
                                        fdata.append('po_shipping_address[]', po.shipping_address)
                                        fdata.append('po_shipping_city[]', po.shipping_city)
                                        fdata.append('po_shipping_country[]', po.shipping_country)
                                        fdata.append('po_shipping_state[]', po.shipping_state)
                                        fdata.append('po_shipping_zip[]', po.shipping_zip)
                                    }
                                } else {
                                    let po = this.paymentMethod[prop]
                                    fdata.append('po_number[]', po.number)
                                    Array.from(po.file).forEach(file => {
                                        fdata.append('po_file[0][]', file, file.name)
                                    })
                                }
                            } else {
                                if ( prop == 'delivery_date' && !this.paymentMethod[prop] && this.shippingDetail[prop] ) {
                                    // continue;
                                } else {
                                    fdata.append(prop, this.paymentMethod[prop])
                                }
                            }
                        }
                        // end

                        // Purchase
                        this.$http.post('/api/settings/purchase', fdata, { headers: { 'Content-Type': 'multipart/form-data' } })
                            .then((response) => {
                                if ( response.data.type == 'success' ) {
                                    this.purchased_id = this.survey.id;
                                    this.purchaseStep = 3;
                                    this.$emit('reload', true);
                                } else {
                                    alert('Something went wrong!')
                                }
                                this.isStepLoading = false;
                            })
                            .catch((error) => {
                                alert(error.response.data.message)
                                this.isStepLoading = false
                            })

                    }, 1000)

                    break;
                }
                case 3: { // Confirmation
                    break;
                }
            }
        },
        setItemChanges({changes}) {
            // console.log('changes',changes);
            this.itemChanges = changes;
        },
        reviewStep({reviewed}) {
            this.itemsDone = reviewed;
        },
        prevStep() {
            if(this.purchaseStep > 1) {
                this.purchaseStep--
            }
        },
        getPaymentMethod(data) {
            this.paymentMethod = data
        },
        getDSStatus(status) {
            this.DSStatus = status
            if(status == 'completed') {

                if ( this.purchaseStepLimit == 2) {
                    this.showConfirm = true;
                    /*this.isStepLoading = true;
                    // Purchase
                    this.$http.post('/api/settings/order/'+this.survey.id)
                        .then((response) => {
                            // alert('Purchase Request has been submitted.');
                            console.log(response);
                            this.purchased_id = this.survey.id;
                            this.$emit('reload', true);
                            this.purchaseStep = 4;
                            this.isStepLoading = false;
                        })
                        .catch((error) => {
                            alert(error.response.data.message)
                            this.isStepLoading = false
                        })*/
                } else {
                    this.purchaseStep = 3
                }
            }
        },
        getShippingDetail(data) {
            this.shippingDetail = data
        },
        close() {
            this.show = false
            this.$emit('close', true)
        },
        get_cars() {
            this.showConfirm = false;
            // console.log('get car', this.survey.id);
            // console.log('purch data', this.survey);
            this.stype = this.survey.type;
            if ( this.survey.status == 'REQUESTED' && this.survey.pdf_ds_documents ) {
                this.DSStatus = 'completed';
                this.pdf_ds_documents = this.survey.pdf_ds_documents;
            }
            if(this.survey.id != undefined) {
                this.$http.get('/api/settings/project_cars/' + this.survey.id)
                    .then((response) => {
                        this.cars = response.data.inputs;
                        this.items = response.data.items;
                        this.tax = response.data.tax;
                        this.tariff = response.data.tariff;
                        this.drop_ship_fee = response.data.drop_ship_fee;
                        this.freight_surcharge = response.data.freight_surcharge;
                        this.reels = response.data.reels;
                        this.itemLeadTime = response.data.lead_time;
                    })
            }
        },
        get_customer_details() {

            var user = localStorage.getItem('user');
            this.user = JSON.parse(user);

            // this.purchaseStepLimit = this.user.can_purchase == 3 ? 2 : 4;

            this.$http.get('/api/purchase/get-details?pid='+this.survey.id, { id: this.survey.id })
                .then((response) => {
                    this.customer_details = response.data
                })
        },
        getPoByCar(n) {
            this.po_by_car = n
        }
    }
}
</script>
<style lang="scss" scoped>
.confirmation { width: 100%; height: calc(100vh -  317px); }
.modal::v-deep {
    .modal-dialog {
        max-width: 98%;
    }
}
</style>